module.exports = __webpack_public_path__ + "img/web.32b1a745.svg";